// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import PreviewResource from './data'

export default function PreviewResourceFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/PreviewResource">
      <PreviewResource {...props}>
        {children}
      </PreviewResource>
    </Flow>
  )
}
